import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgForm } from '@angular/forms';
import { GridComponent } from '@progress/kendo-angular-grid';
import { CommonMethod } from 'src/app-core/methods/common-methods';
import { CommonService } from 'src/app-core/services/common.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { CommonDataModel } from '../common-data-model';
import { OrdersFreightShopperListComponent } from '../orders-freight-shopper-list/orders-freight-shopper-list.component';

@Component({
    selector: 'app-orders-carrier-costs-list',
    templateUrl: './orders-carrier-costs-list.component.html',
    styleUrls: ['./orders-carrier-costs-list.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})

export class OrdersCarrierCostsListComponent extends AppComponentBase implements OnInit {

    @ViewChild('grid', { static: true }) private grid: GridComponent;
    @ViewChild('FreightShopper', { static: false }) FreightShopper: OrdersFreightShopperListComponent;
    @ViewChild('carrierCostForm', { static: true }) carrierCostForm: NgForm;

    @Input() set shippingInfoParams(data: any) {
        this.shippingInfo = data;
        this.ShipToDetails = this.shippingInfo && this.shippingInfo.shippingTo
            && this.shippingInfo.shippingTo.city ? `${this.shippingInfo.shippingTo.city}, ${this.shippingInfo.shippingTo.provinceName}, ${this.shippingInfo.shippingTo.zipCode}` : '';
        this.ShipFromDetails = this.shippingInfo && this.shippingInfo.shippingFrom
            && this.shippingInfo.shippingFrom.city ? `${this.shippingInfo.shippingFrom.city}, ${this.shippingInfo.shippingFrom.provinceName}, ${this.shippingInfo.shippingFrom.zipCode}` : '';
        this.ShipIntermediaryDetails = this.shippingInfo && this.shippingInfo.intermediary
            && this.shippingInfo.intermediary.city ? `${this.shippingInfo.intermediary.city}, ${this.shippingInfo.intermediary.provinceName}, ${this.shippingInfo.intermediary.zipCode}` : '';
    }
    @Input() containers: any;
    @Input() set carrierCostParams(data: any) {
        this.carrierCost = data;
        if (this.carrierCost && this.carrierCost.containerDetails) {
            this.carrierCostsList = {
                dimWeightFactorId: this.carrierCost.dimWeightFactorId,
                carrierId: this.carrierCost.carrierId,
                serviceName: this.carrierCost.serviceName,
                serviceDate: this.carrierCost.serviceDate,
                shippingCost: this.carrierCost.shippingCost,
                carrierCostId: this.carrierCost.carrierCostId,
                carrierName: this.carrierCost.carrierName,
                pro: this.carrierCost.pro,
                transitDays: this.carrierCost.transitDays
            };
            if (!this.gridItems.data) {
                this.gridItems.data = [];
            }
            const updatedContainerIds = this.carrierCost.containerDetails.map(
                newItem => newItem.itemContainerId
            );
            this.gridItems.data = this.gridItems.data.filter(
                existingItem => updatedContainerIds.includes(existingItem.itemContainerId)
            );
            this.carrierCost.containerDetails.forEach(newItem => {
                const index = this.gridItems.data.findIndex(
                    existingItem => existingItem.itemContainerId === newItem.itemContainerId
                );
    
                if (index !== -1) {
                    this.gridItems.data[index] = {
                        ...this.gridItems.data[index],
                        ...newItem
                    };
                } else {
                    this.gridItems.data.push(newItem);
                }
            });
            this.totals = this.carrierCost.totals;
        }
    }
    @Input() isPanelExpended: boolean;
    @Input() readOnly: boolean;
    @Output() emitShippingInfoFrom: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitOrdersToOrIntermediaryAddress: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitFreightShopperCostToEstimateBreakdown: EventEmitter<any> = new EventEmitter<any>();
    commonDataModel = new CommonDataModel();
    carrierCostsList = this.commonDataModel.carrierCostsListModel;
    totals = this.commonDataModel.carrierCostsTotalsModel;
    dimWeightFactorItem = { dimWeightFactorName: 'Select', id: null };
    carrierItem = { carrierName: 'Select', carrierId: null };
    isCarrierCost = true;
    carrierItemList = [];
    isFormLoading = false;
    ShipToDetails: string;
    ShipFromDetails: string;
    ShipIntermediaryDetails: string;
    carrierCost: any;
    shippingInfo: any;
    gridItems: any = {
        data: [],
        total: 0
    };
    dimWeightFactors: any;
    frenchiseCity: any = this.commonService.getTCity();
    frenchiseState: any = this.commonService.getTState();
    frenchiseZip: any = this.commonService.getTZipcode();
    accessorials: any;
    isFV: boolean;
    isFVPermission: boolean;

    constructor(
        injector: Injector,
        private commonService: CommonService,
        private commonMethod: CommonMethod) {
        super(injector);
    }


    ngOnInit(): void {
        this.commonMethod.getIsInternationalZipcode.subscribe((data: any) => {
            if (data) {
                const domesticOption = this.dimWeightFactors.find(factor => factor.id === 166);
                this.carrierCostsList.dimWeightFactorId = domesticOption.id;
                this.carrierCostForm.form.markAsDirty();
            } else {
                this.carrierCostsList.dimWeightFactorId = 194;
            }
        })
        this.isFV = this.commonService.getTenentIsFreightViewIntegrated();
        this.isFVPermission = this.commonService.permissionCheckByName('FreightView');
        this.getCarriersList();
        this.getDimWeightFactors();
    }

    // start getCarriersList
    getCarriersList() {
        const queryString = `CarrierId=${this.carrierCostsList.carrierId === null ? 0 : this.carrierCostsList.carrierId}`;
        this.commonService.getCarriersList(queryString).subscribe((response: any) => {
            if (response.isSuccess) {
                this.carrierItemList = response.data;
                this.carrierItemList = this.carrierItemList.filter(item => item.isAvailableForOrder);
            }
        });
    }
    // end getCarriersList

    // start getCarriersList
    getDimWeightFactors() {
        this.commonService.getDimWeightFactors().subscribe((response: any) => {
            this.dimWeightFactors = response.data;
        });
    }
    // end getCarriersList

    emitFreightSopperDetails(data: any): void {
        if (data) {
            this.carrierCostForm.form.markAsDirty();
            if (data.isReset) {
                this.onResetFreightShopperCarrierData();
                return;
            }
            this.carrierCostsList.carrierId = data.carrierId;
            this.carrierCostsList.serviceName = data.serviceTypeName;
            this.carrierCostsList.serviceDate = data.deliveryDate;
            this.carrierCostsList.shippingCost = data.shippingCost;
            this.carrierCostsList.carrierName = data.carrierName;
            this.carrierCostsList.transitDays = data.transitDays;
            this.carrierCostsList.pro = data.pro;
            // default first record
            this.carrierCostsList.dimWeightFactorId = this.dimWeightFactors[0].id;
            this.emitFreightShopperCostToEstimateBreakdown.emit(data.shippingCost);
        }
    }

    emitSelectedAccessorials(data: any) {
        if (data) {
            this.accessorials = data;
        }
    }

    onResetFreightShopperCarrierData() {
        this.carrierCostsList.carrierId = null;
        this.carrierCostsList.serviceName = null;
        this.carrierCostsList.serviceDate = null;
        this.carrierCostsList.shippingCost = null;
        this.carrierCostsList.carrierName = null;
        this.carrierCostsList.pro = null;
        this.emitFreightShopperCostToEstimateBreakdown.emit(0);
    }

    onCarrierChange(event: any) {
        this.carrierCostsList.carrierName = event.carrierName;
    }

    onChangeAddressForShipFromOrigin(event, address: any) {
        if (event.checked) {
            address.isShipperAddress = true;
            this.emitShippingInfoFrom.emit(address);
        } else {
            // frenchise address
            address.isShipperAddress = false;
            this.emitShippingInfoFrom.emit(address);
        }
        this.carrierCostForm.form.markAsDirty();
    }

    onChangeAddressForShipToThirdParty(event, address: any) {
        if (event.checked) {
            address.isConsigneeAddress = true;
            this.emitOrdersToOrIntermediaryAddress.emit('ordersIntermediaryIsConsigneeAddress');
        } else {
            // Ship To address
            address.isConsigneeAddress = false;
            this.emitOrdersToOrIntermediaryAddress.emit('ordersToIsConsigneeAddress');
        }
        this.carrierCostForm.form.markAsDirty();
    }

}
